export const USERDATAADDRESS_SHOW_RESET = 'USERDATAADDRESS_SHOW_RESET'
export const USERDATAADDRESS_SHOW_SET_ERROR = 'USERDATAADDRESS_SHOW_SET_ERROR'
export const USERDATAADDRESS_SHOW_SET_RETRIEVED = 'USERDATAADDRESS_SHOW_SET_RETRIEVED'
export const USERDATAADDRESS_SHOW_TOGGLE_LOADING = 'USERDATAADDRESS_SHOW_TOGGLE_LOADING'
